import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { WhoAmI } from '../../model/user/whoAmI.model';
import { ILoginModel } from '../../model/user/login.model';
import { UserContextService } from '../../context/user.context.service';
import { CoreConstant } from '../../constant/base.constant';
import { EnvironmentConfig } from '../../model/environment.model';
import { ENV_CONFIG } from '../../injection-tokens/environment.token';

@Injectable({
    providedIn: 'root',
})
export class LoginService {
    private readonly _userContextService: UserContextService = inject(UserContextService);
    private readonly _httpClient: HttpClient = inject(HttpClient);
    private readonly _environment: EnvironmentConfig = inject(ENV_CONFIG);

    redirectUrl: string | null = null;

    public login(model: ILoginModel): Observable<WhoAmI> {
        const loginForm = new FormData();

        for (const [key, value] of Object.entries(model)) {
            loginForm.append(key, value);
        }

        return this._httpClient
            .post<WhoAmI>(`${this._environment.APP.VC_USER_BASE_URL}/login`, loginForm, {
                observe: 'response',
            })
            .pipe(
                map((response) => {
                    this._setSession(response);
                    return response.body as WhoAmI;
                })
            );
    }

    public logout(): Observable<void> {
        this.redirectUrl = null;
        return this._httpClient.post<void>(`${this._environment.APP.VC_USER_BASE_URL}/logout`, {});
    }

    private _setSession(response: HttpResponse<WhoAmI>): void {
        const userToken = response.headers.get(CoreConstant.X_AUTH_TOKEN);
        this._userContextService.setToken(userToken);
    }
}
